// © 2015-2021 WDNA - All Rights Reserved

import Adjustments from './loaders/Adjustments';
import Firmwares from './loaders/Firmwares';
import Readings from './loaders/Readings';
import Sensors from './loaders/Sensors';
import Graphs from './loaders/Graphs';
import WasteContainers from './loaders/Waste';
import Reports from './loaders/Reports';

export const redirects: any[] = [
  {
    from: '/sensors',
    to: '/sensors/sensors',
  },
];

export const routes: any[] = [
  {
    component: Adjustments,
    path: '/sensors/adjustments',
  },
  {
    component: Firmwares,
    path: '/sensors/firmwares',
  },
  {
    component: Readings,
    path: '/sensors/readings',
  },
  {
    component: Sensors,
    path: '/sensors/sensors',
  },
  {
    component: Graphs,
    path: '/sensors/sensors_graphs',
  },
  {
    component: WasteContainers,
    path: '/sensors/waste',
  },
  {
    component: Reports,
    path: '/sensors/reports',
  },
];
